import React from "react";
import { iconProps } from "../../Helper";

const DeleteIcon=({className}:iconProps)=> {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_10949_22687"
        style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="18"
      >
        <rect width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_10949_22687)">
        <path
        className={className}
          d="M5.48081 15.3748C5.10681 15.3748 4.78731 15.2424 4.52231 14.9775C4.25744 14.7125 4.125 14.393 4.125 14.019V4.4998H3.375V3.3748H6.75V2.71143H11.25V3.3748H14.625V4.4998H13.875V14.019C13.875 14.3979 13.7438 14.7186 13.4813 14.9811C13.2188 15.2436 12.8981 15.3748 12.5192 15.3748H5.48081ZM12.75 4.4998H5.25V14.019C5.25 14.0864 5.27162 14.1417 5.31487 14.1849C5.35812 14.2282 5.41344 14.2498 5.48081 14.2498H12.5192C12.5769 14.2498 12.6298 14.2257 12.6778 14.1776C12.7259 14.1296 12.75 14.0767 12.75 14.019V4.4998ZM7.053 12.7498H8.17781V5.9998H7.053V12.7498ZM9.82219 12.7498H10.947V5.9998H9.82219V12.7498Z"
          fill="white"
        />
      </g>
    </svg>
  );
}

export default DeleteIcon;
